export default "__VITE_ASSET__Cgv7DiPw__"